import { defineModel } from "../define-model";

export type WorkspaceMember = {
	id: string;
	workspaceId: string;
	userId: string;
	roleId: string;
	invitedById: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		workspaceMember: WorkspaceMember;
	}
}

export const model = defineModel({
	name: "workspaceMember",
	load: "eager",
	indexes: ["userId", "roleId"],
});
